<template>
    <div>
        <div v-if="loading_page === true">
            <v-sheet :color="`grey ${theme.isDark ? 'darken-2' : 'lighten-4'}`" class="pa-3">
                <v-skeleton-loader type="article, actions"></v-skeleton-loader>
            </v-sheet>
        </div>
        <div class="mt-1" v-else>
            <v-row >
                <v-col xs="12" sm="12" md="9" lg="10" xl="10" cols="12">
                    <div class="title_page ma-3">
                        <h4 class="breadcrumb_title_page">รายละเอียด Tax Refund</h4>
                        <v-breadcrumbs :items="sub_menu">
                            <template v-slot:divider>
                            <v-icon>mdi-chevron-right</v-icon>
                            </template>
                        </v-breadcrumbs>
                    </div>
                </v-col>
                <v-col xs="12" sm="12" md="3" lg="2" xl="2" cols="12">
                    <div class="title_page ma-3">
                        <v-btn type="button" class="btn_back_page" elevation="4" @click="$router.back()" large>ย้อนกลับ</v-btn>
                    </div>
                </v-col>
                
            </v-row>
            <div class="ma-5">
                <v-card elevation="4" class="pa-3 card_relative mb-10" style="height:100%;">
                    <div class="tag_header_profile title_page">
                        <div class="grad-dark-brown-arin-bg pa-3 rounded-pill" style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                            <div class="logo_timeline mx-auto my-auto">
                                <img src="@/assets/arin_assets/box.png">
                            </div>
                        </div>
                        <v-card elevation="3" class="card_title ml-n5">
                            <div class="arin-text-color d-flex align-center py-2 pl-8 pr-5">
                                <div>ข้อมูลใบเสร็จ</div>
                            </div>
                        </v-card>
                    </div>
                    <v-row class="ma-4 mt-6">
                        <v-col cols="6">
                            <span class="text-grey"> เลขที่ใบเสร็จ : </span> {{data_list.invoice_code}}
                        </v-col>
                        <v-col cols="6">
                            <span class="text-grey"> วันที่เอกสาร : </span> {{diffDateTH_Departure(data_list.doc_date)}}
                        </v-col>
                    </v-row>
                </v-card>

                
                <v-card elevation="3" class="pa-5 mt-15 " style="border-radius: 15px;">
                    <div class="tag_header_profile title_page">
                        <div class="grad-dark-brown-arin-bg pa-3 rounded-pill" style="box-shadow: 0 4px 4px rgba(0, 0, 0, 0.25);z-index: 1">
                            <div class="logo_timeline mx-auto my-auto">
                                <img style="width: 25px;height: 25px;" src="@/assets/arin_assets/tax.png">
                            </div>
                        </div>
                        <v-card elevation="3" class="card_title ml-n5">
                            <div class="arin-text-color d-flex align-center py-2 pl-8 pr-5">
                                <div>ข้อมูลใบ tax Refund</div>
                            </div>
                        </v-card>
                    </div>
                    <section class="pa-3">
                        <v-row class="pl-5">
                            <v-col cols="12" xl="6" lg="6" md="12" sm="12" >
                                <v-card :loading="loading" class="mx-auto my-6 input-radius">
                                    <template slot="progress">
                                        <v-progress-linear
                                            color="deep-purple"
                                            height="10"
                                            indeterminate
                                        ></v-progress-linear>
                                    </template>

                                    <v-card-title class="font-16 py-1 text-center bold header_card">
                                        FOR RETAILER :
                                    </v-card-title>

                                     <v-card-text>
                                            <v-row>
                                                <v-col class="my-3 mb-0">
                                                    <div class="font-18 sub_header">สำหรับผู้ขาย</div>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col cols="8" class="pb-2">
                                                    <div class="font-16"> <span class="text-grey"> เลขประจำตัวผู้เสียภาษีอากร :</span> {{seller.store_personal_id}}</div>
                                                </v-col>
                                                <v-col cols="4" class="pb-2">
                                                    <div class="font-16"> <span class="text-grey"> สาขาที่ : </span> {{ seller.store_code != null ? seller.store_code : '-'}}</div>
                                                </v-col>
                                                <v-col cols="12 pt-0 pb-2">
                                                    <div class="font-16"> <span class="text-grey"> ชื่อผู้ประกอบการ : </span>  {{seller.status_main_store == 1 ? 'บริษัท ฟาร์มาแคร์ พลัส จำกัด' : seller.store_name}} </div>
                                                </v-col>
                                                <v-col cols="12 pt-0 pb-2">
                                                    <div class="font-16"> 
                                                        <span class="text-grey">  สถานประกอบการที่จัดทำ ภ.พ.10 เลขที่ :  </span> 
                                                        <div class="mt-1 line-h"> {{seller.address}} {{seller.address_list}}</div>
                                                    </div>
                                                </v-col> 
                                                <v-col cols="12 pt-0">
                                                    <div class="font-16"> <span class="text-grey">  โทรศัพท์ :  </span> {{seller.tel}}</div>
                                                </v-col>
                                            </v-row>

                                            <v-row>
                                                <v-col>
                                                    <v-simple-table fixed-header height="400px" class="border-grey">
                                                        <template v-slot:default>
                                                            <thead>
                                                                <tr>
                                                                    <th class="text-center" width="50">
                                                                        <div>ITEMS</div>
                                                                        <div class="text-grey">รายการ</div>
                                                                    </th>
                                                                    <th class="text-center">
                                                                        <div> Description of goods</div>
                                                                        <div class="text-grey"> รายการสินค้า</div>
                                                                    </th>
                                                                    <th class="text-center" width="80">
                                                                        <div>Quantity</div>
                                                                        <div class="text-grey">จำนวน</div>
                                                                    </th>
                                                                    <th class="text-center" width="160">
                                                                        <div> Price (Vat included) </div>
                                                                        <div class="text-grey"> ราคา (รวมภาษีมูลค่าเพิ่ม) </div>
                                                                    </th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr v-for="(item, index) in data_list.product_list" :key="index"  >
                                                                    <td class="text-center border-empty">{{ index+1 }}</td>
                                                                    <td class="border-empty">{{ item.product_name }}</td>
                                                                    <td  class="text-center border-empty">{{ parseInt(item.qty) }}</td>
                                                                    <td v-if="item.is_promotion == 1" class="text-right border-empty">-{{ formatPrice(item.total) }}</td>
                                                                    <td v-else class="text-right border-empty">{{ formatPrice(item.total) }}</td>
                                                                </tr>
                                                            </tbody>
                                                        </template>
                                                    </v-simple-table>
                                                </v-col>
                                            </v-row>
                                        </v-card-text>

                                    <v-card-title class="line-h-0">
                                            <v-row>
                                                <v-col cols="12" lg="4" xl="4"></v-col>
                                                <v-col class="font-16" cols="7" lg="5" xl="5" >
                                                   <div>Total Payment </div>
                                                   <div class="text-grey">จำนวนเงิน</div>
                                                </v-col>
                                                 <v-col class="font-16" cols="5" lg="3" xl="3">{{formatPrice(data_list.total_payment)}}</v-col>
                                                <!-- <v-col v-else class="font-16" cols="5" lg="3" xl="3">{{formatPrice(parseFloat(data_list.total_payment) + (parseFloat(parseFloat(data_list.total_payment) * (parseFloat(seller.credit_charge_status) == 1 ? parseFloat(seller.credit_charge) / 100 : 0))))}}</v-col> -->
                                                <v-col cols="12 py-0" lg="4" xl="4"></v-col>
                                                <v-col class="font-16" cols="7" lg="5" xl="5">
                                                    <div>Total VAT</div>
                                                    <div class="text-grey">จำนวนเงินภาษีมูลค่าเพิ่ม</div>
                                                </v-col>
                                                <v-col class="font-16" cols="5" lg="3" xl="3">{{data_list.total_vat}}</v-col>
                                                <!-- <v-col v-if="data_list.pay_type.find(o => o === 3)" cols="12 py-0" lg="4" xl="4"></v-col>
                                                <v-col v-if="data_list.pay_type.find(o => o === 3)" class="font-16" cols="7" lg="5" xl="5">
                                                    <div>Credit Charge {{parseFloat(seller.credit_charge)}} %</div>
                                                    <div class="text-grey">จำนวนเงินภาษีเครดิตมูลค่าเพิ่ม</div>
                                                </v-col>
                                                <v-col v-if="data_list.pay_type.find(o => o === 3)" class="font-16" cols="5" lg="3" xl="3">{{formatPrice((parseFloat(parseFloat(data_list.total_payment) * (parseFloat(seller.credit_charge_status) == 1 ? parseFloat(seller.credit_charge) / 100 : 0))))}}</v-col> -->
                                                <v-col cols="12 py-0" lg="4" xl="4"></v-col>
                                                <v-col class="font-16" cols="7" lg="5" xl="5">
                                                    <div> Total VAT/Refundable</div>
                                                    <div class="text-grey">จำนวนเงินภาษีมูลค่าเพิ่มที่ขอคืน</div>
                                                </v-col>
                                                <v-col class="font-16" cols="5" lg="3" xl="3">{{data_list.total_vat_refund}}</v-col>
                                            </v-row>
                                        </v-card-title>

                                </v-card>

                            </v-col>

                            <v-col cols="12" xl="6" lg="6" md="12" sm="12" >
                                <v-card :loading="loading" class="mx-auto my-6 input-radius">
                                    <template slot="progress">
                                        <v-progress-linear
                                            color="deep-purple"
                                            height="10"
                                            indeterminate
                                        ></v-progress-linear>
                                    </template>

                                    <v-card-title class="header_card font-16 py-1 text-center bold">FOR TOURIST :</v-card-title>

                                    <v-card-text>
                                        <v-row>
                                            <v-col class="my-3 mb-0">
                                                <div class="font-18 sub_header bold">สำหรับนักท่องเที่ยว</div>
                                            </v-col>
                                        </v-row>
                                        
                                        <v-row>

                                            <v-col cols="12 py-1"> 
                                                <v-form-group>
                                                    <label class="label_form_text">ชื่อนักท่องเที่ยว/Name of Tourist/Claimant : </label> <span class="font-16 bold">{{data_list.tourist_name}}</span>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">สัญชาติ/Nationality : <span class="font-16 bold">{{data_list.nationality}}</span></label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">เลขที่หนังสือเดินทาง/Passport No. : <span class="font-16 bold">{{data_list.passport_no}}</span> </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">วันที่เดินทางถึง/Arrival Date : <span class="font-16 bold">{{data_list.arrival_date == null ? '-' : diffDateTH_Departure(data_list.arrival_date)}}</span> </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">วันที่เดินทางออก/Departure Date : <span class="font-16 bold">{{data_list.departure_date == null ? '-' : diffDateTH_Departure(data_list.departure_date)}}</span>  </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">เลขที่เที่ยวบิน/Flight No. : <span class="font-16 bold">{{data_list.flight_no}}</span> </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">ที่อยู่ในต่างประเทศ/Permanent/Mailing Address :</label>
                                                    <div class="font-16 bold">{{data_list.address}}</div>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1" md="6" lg="6" sl="6">
                                                <v-form-group>
                                                    <label class="label_form_text">รหัสไปรษณีย์/Postcode :  <span class="font-16 bold">{{data_list.postcode}}</span> </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1" md="6" lg="6" sl="6">
                                                <v-form-group>
                                                    <label class="label_form_text">เมือง/City :  <span class="font-16 bold">{{data_list.city}}</span> </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">ประเทศ/Country :  <span class="font-16 bold">{{data_list.country}}</span>  </label>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 py-1">
                                                <v-form-group>
                                                    <label class="label_form_text">อีเมล/Email : <span class="font-16 bold">{{data_list.email}}</span> </label>
                                                    
                                                </v-form-group>
                                            </v-col>


                                            <v-col cols="12 pb-0">
                                                    <div class="font-16 bold">Refund to be receives in one of the following forms</div>
                                                    <div class="font-16 text-grey"> ข้าพเจ้าประสงค์จะขอรับคืนเงินภาษี เป็น</div>
                                                </v-col>
                                                <v-radio-group v-model="data_list.refund_type">
                                                <v-col cols="12 title_page_end py-0">
                                                    <v-radio class="pt-0" color="orange" value="0" disabled></v-radio>
                                                    <div class="grid font-16">Cash in Thai baht (in case that the refund is not exceeding 30,000 baht)
                                                        <span class="text-grey">เงินสด (ในกรณีขอคืนภาษีไม่เกิน 30,000 บาท)</span>
                                                    </div>
                                                </v-col>

                                                <v-col cols="12 title_page_end py-0">
                                                    <v-radio class="pt-0" color="orange" indeterminate value="1" disabled></v-radio>
                                                    <div class="grid font-16 ">Draft
                                                        <span class="text-grey">ดราฟต์</span>
                                                    </div>
                                                </v-col>

                                                <v-row v-if="data_list.refund_type == '1'">
                                                    <v-radio-group v-model="data_list.draft_type">
                                                    <v-row>
                                                        <v-col cols="auto">
                                                    <v-radio value="0" class="pa-0 ma-0 pl-7 font-16" label="USD" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="1" class="pa-0 ma-0 pl-7 font-16" label="Euro" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="2" class="pa-0 ma-0 pl-7 font-16" label="Yen" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="3" class="pa-0 ma-0 pl-7 font-16" label="Pound Sterling" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                    </v-row>
                                                </v-radio-group>
                                                </v-row>

                                                <v-col cols="12 title_page_end py-0">
                                                    <v-radio class="pt-0" color="orange" indeterminate value="2" disabled></v-radio>
                                                    <div class="grid font-16">  Credit Card (Must be the same as that of the claimant)
                                                        <span class="text-grey">บัตรเครดิต</span>
                                                    </div>
                                                </v-col>

                                               <v-row v-if="data_list.refund_type == '2'">
                                                 <v-radio-group v-model="data_list.credit_type">
                                                 <v-row>
                                                    <v-col cols="auto">
                                                    <v-radio value="0" class="pa-0 ma-0 pl-7 font-16" label="VISA" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="1" class="pa-0 ma-0 pl-7 font-16" label="Dinners" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="2" class="pa-0 ma-0 pl-7 font-16" label="JCB" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                <v-col cols="auto">
                                                    <v-radio value="3" class="pa-0 ma-0 pl-7 font-16" label="Master Card" color="orange" hide-details indeterminate disabled></v-radio>
                                                </v-col>
                                                 </v-row>
                                                 </v-radio-group>
                                               </v-row>
                                                </v-radio-group>
                                                 <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 " v-if="data_list.refund_type == '2'">
                                                    <v-form-group>
                                                        <label class="label_form_text">ชื่อบนบัตร/Name of credit cardholder </label>
                                                         <span class="font-16 bold">{{data_list.name_of_credit}}</span>
                                                    </v-form-group>
                                                </v-col>
                                                <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 " v-if="data_list.refund_type == '2'">
                                                    <v-form-group>
                                                        <label class="label_form_text">เลขที่บัตร/card No. (Should not expire in the next 6 months) </label>
                                                        <span class="font-16 bold">{{data_list.card_no}}</span>
                                                    </v-form-group>
                                                    
                                                </v-col>
                                                <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 " v-if="data_list.refund_type == '2'">
                                                    <v-form-group>
                                                        <label class="label_form_text">หมดอายุวันที่/Expiry Date </label>
                                                       <span class="font-16 bold">{{data_list.expiry_date}}</span>
                                                    </v-form-group>
                                                </v-col>

                                            <!-- <v-col cols="12 title_page_end py-0">
                                                <v-checkbox class="pt-0" v-model="refund_radio_receives_sub_draft" color="orange" indeterminate disabled></v-checkbox>
                                                <div class="grid font-16 ">Draft
                                                    <span class="text-grey">ดราฟต์</span>
                                                </div>
                                            </v-col>

                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="USD" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="Euro" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="Yen" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="Pound Sterling" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>

                                            <v-col cols="12 title_page_end py-0">
                                                <v-checkbox class="pt-0" v-model="refund_radio_receives_sub_credit" color="orange" indeterminate disabled></v-checkbox>
                                                <div class="grid font-16">  Credit Card (Must be the same as that of the claimant)
                                                    <span class="text-grey">บัตรเครดิต</span>
                                                </div>
                                            </v-col>

                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="VISA" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="Dinners" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="JCB" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>
                                            <v-col cols="auto">
                                                <v-checkbox class="pa-0 ma-0 pl-7 font-16" label="Master Card" v-model="refund_radio_receives_sub_draft" color="orange" hide-details indeterminate disabled></v-checkbox>
                                            </v-col>

                                            <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 ">
                                                <v-form-group>
                                                    <label class="label_form_text">ชื่อบนบัตร/Name of credit cardholder </label>
                                                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-account"
                                                    hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="refund_sub_credit_name"
                                                    placeholder="กรุณากรอกชื่อบนบัตร" single-line outlined dense required></v-text-field>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 ">
                                                <v-form-group>
                                                    <label class="label_form_text">เลขที่บัตร/card No. (Should not expire in the next 6 months) </label>
                                                    <v-otp-input class="mh-40" length="16" type="number" placeholder="x" v-model="refund_sub_credit_card_no" outlined dense></v-otp-input>
                                                </v-form-group>
                                            </v-col>

                                            <v-col cols="12 pt-2" md="12" lg="12" sl="12" class="pl-10 ">
                                                <v-form-group>
                                                    <label class="label_form_text">หมดอายุวันที่/Expiry Date </label>
                                                    <v-text-field color="#D6BFAF" class="input-radius" prepend-inner-icon="mdi-clock-alert"
                                                    hide-details="auto" :rules="[v => !!v || 'กรุณากรอกข้อมูล']" v-model="refund_sub_credit_card_exp"
                                                    placeholder="กรุณากรอกหมดอายุวันที่" single-line outlined dense required></v-text-field>
                                                </v-form-group>
                                            </v-col> -->

                                        </v-row>
                                    </v-card-text>
                                </v-card>
                            </v-col>
                        </v-row>
                    </section>
                </v-card>
            </div>
        </div>
    </div>
</template>
  
<script>
import { HTTP_ARIN } from "@/axios_arin";
  import { formatPrice } from "@/js/handler";
export default {
    inject: {
        theme: {
            default: {
                isDark: false,
            },
        },
    },
    name: "Pos_invoices_tax_refund_detail",
    data() {
        return {
            loading_page: false,
            dialog_cancel_order: false,
            invoice_item: [
                'inv-15774124',
                'inv-15774123',
                'inv-15774122',
            ],
            footer_Props:{
                'items-per-page-text':'รายการต่อหน้า'
            },

            data_list: {},
            sub_menu:[
                {
                    text:'ระบบ POS',
                    disabled:false,
                },
                {
                    text:'การขาย',
                    disabled:false,
                },
                {
                    text:'ใบ Tax Refund',
                    disabled:false,
                },
                {
                    text:'รายละเอียด Tax Refund',
                    disabled:false,
                },
            ],
            seller: {
                pay_type: [],
                credit_charge_status: null,
                credit_charge: null
            },
        }
    }, methods: {
        formatPrice(number){
            return formatPrice(number)
        },
        diffDateTH_Arrival(value){
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0])+543
            const final_date = day+'/'+month+'/'+year
            return final_date
        },

        diffDateTH_Departure(value){
            const diff = value.split('-')
            const day = diff[2]
            const month = diff[1]
            const year = parseInt(diff[0])+543
            const final_date = day+'/'+month+'/'+year
            return final_date
        },
         async getTaxRefundDetail(){
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let id = this.$route.params.id;
            await HTTP_ARIN.get('/tax/refund/'+id, config).then((res) => {
                if (res.data.successful === true) {
                    this.data_list = res.data.data;
                    this.getNationalToSelectbox(this.data_list.nationlity_id)
                }
            })
         },
         async getStoreDetail(){
             let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            let store_id = this.$store.state.store_arin.user_data.store_id;
            await HTTP_ARIN.get('/stores/detail/' + store_id, config).then((res) => {
                if (res.data.successful === true) {
                    this.seller = res.data.storeDetail;
                    this.seller.credit_charge_status = this.data_list.credit_charge_status;
                    this.seller.credit_charge = this.data_list.credit_charge;
                }
            })
         },
         async getNationalToSelectbox(id){
            let config = {
                headers: {
                    'Content-Type': 'application/json',
                    "Authorization": `Bearer ${this.$store.state.store_arin.access_token}`
                }
            }
            await HTTP_ARIN.get('/tax/refund/nationality', config).then((res) => {
                if (res.data.successful === true) {
                    let national_list = res.data.data;
                    national_list = national_list.find(o => o.id === id)
                    
                    this.data_list = {
                            ...this.data_list,
                            refund_type: this.data_list.refund_type != null ? this.data_list.refund_type+'' : null,
                            draft_type: this.data_list.draft_type != null ? this.data_list.draft_type+'' : null,
                            credit_type: this.data_list.credit_type != null ? this.data_list.credit_type+'' : null,
                            nationality : national_list.nationality
                           
                        }
                         this.getStoreDetail()
                  
                }
            })
         },
    },
    mounted(){
        this.getTaxRefundDetail()
    }
}
</script>
  
<style scoped>
.btn_add_data {
  font-size: 16px;
  color: #FFF;
  background: linear-gradient(90deg, #659264 0%, rgba(136, 179, 88, 0) 100%), #88B358 !important;
  border-radius: 10px;
  /* width: 100%; */
}

.header_card{
    border: 1px solid #D6BFAF;
    border-radius: 10px;
    color: #D6BFAF;
    background-color: #fbf9f7;
    display: flex;
    justify-content: center;
}

.sub_header{
    border-bottom: 1px solid #D9D9D9;
    display: inline;
}

.line-h{
    line-height: 25px;
}

.line-h-0{
    line-height: 1.5rem !important;
}

.mh-40
{
    min-height: 40px !important;
}

.border-grey
{
    border-bottom: 1px solid #e0e0e0;
}
.border-empty{
    border-bottom: 0px !important;
}



.card_relative {
  position: relative;
  border-radius: 15px;
}
.profile_detail {
  display: grid;
  grid-template-columns: 30% 70%;
}
.header_half {
  display: grid;
  grid-template-columns: 50% 50%;
}
.logo_timeline {
  width: 25px;
  height: 25px;
}
.logo_timeline>img {
  max-width: 25px;
}
.tag_header_profile {
  position: absolute;
  top: -30px;
  left: -15px;
}
.arin-text-color {
  color: #84611F;
  font-weight: bold;
  font-size: 16px;
}
.arin-text-color-two {
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}
.card_title {
  margin-top: 1px;
  margin-bottom: 1px;
  border-radius: 10px;
  border: 1px solid #D6BFAF;
}
.preview {
  border-radius: 10px;
}
.employee_box {
  border-radius: 10px;
  border: 1px solid #D6BFAF;
  width: auto;
}
.sub_title {
  font-size: 16px;
}
.image_title {
  font-weight: 500;
  font-size: 16px;
}
.picture_details {
  display: grid;
  grid-template-columns: 40% 60%;
}
.mobile_btn {
  width: 40%;
}
.grid_half {
  display: grid;
  grid-template-columns: 50% 50%;
}

.grid_four_ck {
  display: grid;
  grid-template-columns: 25% 25% 25% 25%;
}

.text_title{
  color: #909090;
  font-weight: bold;
  font-size: 16px;
}

.text_detail{
  color: #616A6B;
  font-weight: bold;
  font-size: 16px;
}

.text_unit{
    font-size: 20px;
}

.v-application {
    padding: 13px !important;
}

.logo_timeline {
    padding: 0px;
}

</style>
  